// build: pakari-search-260517 v5 (履歴ラベルをクリック商品タイトルに変更)
class PredictiveSearch extends SearchForm {
  constructor() {
    super();

    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.defaultSearch = this.querySelector(".default--search");
    this.demoSearch = this.querySelector(".wbsclose");

    this.searchHistory = this.querySelector('search-history');
    // statusElement は検索取得時にも遅延セットされるが、
    // 検索取得前のキーボードナビゲーションでも参照されるためここで初期化
    this.statusElement = this.querySelector('.predictive-search-status');

    this.selectedCategory = '';
    this.setupCategoryListeners();

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.querySelector(".wbsclose")?.addEventListener('click', this.onClick.bind(this));
    // 260517 改修⑥：predictive-search 自身にも mousedown capture でサジェスト商品クリックを捕捉
    this.addEventListener('mousedown', this.onSuggestItemMousedown.bind(this), true);
    this.addEventListener('pointerdown', this.onSuggestItemMousedown.bind(this), true);
  }

  onSuggestItemMousedown(event) {
    const item = event.target?.closest?.('.predictive-search__item, .predictive-search__list-item');
    if (!item) return;
    if (!window.PakariSearchHistory) return;
    // 「クリックした商品のタイトル」を履歴に保存する（入力中ワードではなく）
    const textEl = item.querySelector('.predictive-search__item-heading, .predictive-search__item-title-truncate, .noline_animate') || item;
    const label = (textEl.textContent || '').trim();
    if (!label) return;
    window.PakariSearchHistory.addEntry({
      type: 'search',
      label: label,
      url: '/search?q=' + encodeURIComponent(label) + '&type=product',
    });
  }

  setupCategoryListeners() {
    const select = document.getElementById('SearchFilter');
    if (!select) return;

    this.selectedCategory = select.value?.toLowerCase() || '';

    select.addEventListener('change', (e) => {
      this.setSelectedCategory(e.target.value.toLowerCase());
    });
  }

  setSelectedCategory(category) {
    this.selectedCategory = category;

    const hiddenInput = document.querySelector('#predictive-search-category');
    if (hiddenInput) hiddenInput.value = category;

    if (this.getQuery().length) {
      this.getSearchResults(this.getQuery());
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();

    if (!this.defaultSearch.classList.contains('hidden')) {
      this.defaultSearch.classList.add("hidden");
    }

    // 入力が入った時点で履歴UIは隠す
    if (newSearchTerm.length > 0) {
      this.searchHistory?.hide();
      this.classList.remove('showing-history-only');
    }

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    this.updateSearchForTerm(this.searchTerm, newSearchTerm);
    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    // 表示中のaria-selectedアイテムがある場合のみ preventDefault してsubmitを止める
    // （hidden要素内の古いaria-selectedを拾わないように offsetParent で可視性チェック）
    const selectedVisible = Array.from(this.querySelectorAll('[aria-selected="true"]'))
      .find((el) => el.offsetParent !== null);

    if (!this.getQuery().length || selectedVisible) {
      event.preventDefault();
      // 可視のaria-selectedがある場合は keyup→selectOption が遷移処理を担当する
      return;
    }
    // 通常のsubmit時：履歴に保存
    const term = this.getQuery();
    if (term.length && window.PakariSearchHistory) {
      window.PakariSearchHistory.addEntry({
        type: 'search',
        label: term,
        url: '/search?q=' + encodeURIComponent(term) + '&type=product',
      });
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
      // closeResults で [open] と aria-expanded が外れてしまうので、
      // 入力欄にフォーカスが残っており履歴がある場合は再表示する
      // （特にモバイル：[open] が外れると .pakari-mobile-presearch が display:none になり履歴が消える）
      if (document.activeElement === this.input && this.searchHistory?.hasItems?.()) {
        this.classList.add('showing-history-only');
        this.searchHistory.show();
        this.defaultSearch?.classList.add('hidden');
        this.open();
      }
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) {
      // 入力が空のとき、履歴があれば履歴UIのみを表示する。
      // モバイル(.pakari-mobile-presearch)は [open] でなければ非表示なので
      // this.open() を呼ぶ必要があるが、[open] が付くと内部の空 results 枠も出てしまう。
      // → 「履歴のみ表示中」を示すクラスを付与し、CSS側で内部 results 枠だけ隠す。
      if (this.searchHistory && this.searchHistory.hasItems && this.searchHistory.hasItems()) {
        this.classList.add('showing-history-only');
        this.searchHistory.show();
        this.defaultSearch?.classList.add('hidden');
        this.open();
      }
      return;
    }
    // 入力ありに切り替わったときは履歴のみ表示モードを解除
    this.classList.remove('showing-history-only');

    if (this.searchTerm !== currentSearchTerm) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.defaultSearch.classList.add("hidden");
        this.demoSearch.classList.add("hidden");
        this.searchHistory?.hide();
        this.classList.remove('showing-history-only');
        this.close();
      }
    }, 100);
  }

  onClick() {
    setTimeout(() => {
      this.defaultSearch.classList.add("hidden");
      this.demoSearch.classList.add("hidden");
      this.close();
    });
  }

  onKeyup(event) {
    // 履歴のみ表示モードのときは、入力が空でも close しない（キーボード操作可能にするため）
    if (!this.getQuery().length && !this.classList.contains('showing-history-only')) {
      this.close(true);
    }
    // ArrowUp/Down のみ keyup でハンドリング（aria-selected の付け替え）
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
      if (event.code === 'ArrowUp') this.switchOption('up');
      else this.switchOption('down');
    }
  }

  onKeydown(event) {
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
      return;
    }
    // Enter: form submit より先に処理する必要があるため keydown で対応
    if (event.code === 'Enter') {
      const selectedVisible = Array.from(this.querySelectorAll('[aria-selected="true"]'))
        .find((el) => el.offsetParent !== null);
      if (selectedVisible) {
        event.preventDefault();
        event.stopPropagation();
        this.selectOption();
      }
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;

    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g'))?.length > 1) return;
      searchForTextElement.innerText = currentButtonText.replace(previousTerm, newTerm);
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allVisibleElements = Array.from(
      this.querySelectorAll('li, button.predictive-search__item, .search-history__item')
    ).filter(el => el.offsetParent !== null);

    let activeIndex = 0;
    if (moveUp && !selectedElement) return;

    let selectedIndex = -1;
    allVisibleElements.forEach((el, i) => {
      if (el === selectedElement) selectedIndex = i;
    });

    if (this.statusElement) {
      this.statusElement.textContent = '';
    }

    if (!moveUp && selectedElement) {
      activeIndex = selectedIndex === allVisibleElements.length - 1 ? 0 : selectedIndex + 1;
    } else if (moveUp) {
      activeIndex = selectedIndex === 0 ? allVisibleElements.length - 1 : selectedIndex - 1;
    }

    if (activeIndex === selectedIndex) return;

    const activeElement = allVisibleElements[activeIndex];
    activeElement.setAttribute('aria-selected', true);
    selectedElement?.setAttribute('aria-selected', false);
    this.input.setAttribute('aria-activedescendant', activeElement.id || '');
  }

  selectOption() {
    // aria-selectedが付いているli/buttonを取得
    const selectedLi = this.querySelector('li[aria-selected="true"]');
    const selectedBtn = this.querySelector('button[aria-selected="true"]');

    // 履歴アイテム選択時：localStorage上で先頭に移動してから遷移
    if (selectedLi && selectedLi.classList.contains('search-history__item')) {
      const link = selectedLi.querySelector('a.search-history__link');
      if (!link) return;
      const label = selectedLi.dataset.label;
      if (label && window.PakariSearchHistory) {
        const items = window.PakariSearchHistory.read();
        const it = items.find((x) => x.label === label);
        if (it) {
          window.PakariSearchHistory.addEntry({ type: it.type, label: it.label, url: it.url });
        }
      }
      window.location.href = link.href;
      return;
    }

    // サジェスト選択時：クリックされたサジェスト商品のタイトルを履歴保存してから商品ページへ遷移
    if (selectedLi) {
      const anchor = selectedLi.querySelector('a');
      if (!anchor) return;
      if (window.PakariSearchHistory) {
        const textEl = selectedLi.querySelector('.predictive-search__item-heading, .predictive-search__item-title-truncate, .noline_animate') || selectedLi;
        const label = (textEl.textContent || '').trim();
        if (label) {
          window.PakariSearchHistory.addEntry({
            type: 'search',
            label: label,
            url: '/search?q=' + encodeURIComponent(label) + '&type=product',
          });
        }
      }
      window.location.href = anchor.href;
      return;
    }

    // button要素が選択されている場合（"全件を見る"等）：click()
    if (selectedBtn) {
      selectedBtn.click();
    }
  }

  getSearchResults(searchTerm) {
    const normalizedCategory = this.selectedCategory?.trim().toLowerCase();
    const queryKey = (searchTerm + (normalizedCategory || ''))
      .replace(/\s+/g, '-')
      .toLowerCase();

    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const query =
      normalizedCategory && normalizedCategory !== 'all categories'
        ? `${searchTerm} ${normalizedCategory}`
        : searchTerm;

    const searchUrl = `/search?q=${encodeURIComponent(query)}&type=product&section_id=predictive-search`;

    this.abortController.abort();
    this.abortController = new AbortController();

    fetch(searchUrl, { signal: this.abortController.signal })
      .then((response) => {
        if (!response.ok) {
          throw new Error(response.status);
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search')?.innerHTML;
        if (!resultsMarkup) return;
        this.allPredictiveSearchInstances.forEach((instance) => {
          instance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.name === 'AbortError') return;
        this.close();
      });
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');
    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(text) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = text;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(
      this.querySelector('[data-predictive-search-live-region-count-value]')?.textContent || ''
    );
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight =
      this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');
    selected?.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
